import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CModal from '@/components/CModal.vue';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';
import { getTikTokReconnectUrl } from '@/api/storesApp/tiktok';


export default /*#__PURE__*/_defineComponent({
  __name: 'TikTokStoreNeedsReconnectionModal',
  props: {
    sessions: { default: () => [] }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({ (event: 'close'): void }), expose: any, slots: any, attrs: any }) {




const isVisible = ref(true);
const reconnectingShop = ref('');

const onSkip = () => emit('close');

const reconnect = async (shop: string) => {
    reconnectingShop.value = shop;
    try {
        window.open(await getTikTokReconnectUrl(shop), '_parent');
    } catch (error) {
        console.error('Error during TikTok link redirection:', error);
    } finally {
        reconnectingShop.value = '';
    }
};

return { __sfc: true,emit, isVisible, reconnectingShop, onSkip, reconnect, CModal, LoaderBtn }
}

})